import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  useArticle,
  useActionsArticle,
  useDispatchArticleForm,
} from "../../../../../context/inventory/ArticleFormProvider";
import { customStyles } from "../../../../../utilities/select-styles.utilities";
import { useAuth } from "../../../../../context/security/AuthProvider";
import { types } from "../../../../../reducers/inventory/articleReducer";
import { pluckArrayObject } from "../../../../../utilities/math.utilities";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NumericLabel from "../../../../app/atoms/NumericLabel";
import { formatNumberCOP } from "../../../../../utilities/app.utilities";
import { alertWarning } from "../../../../../utilities/alerts.utilities";
const Inventory = () => {
  const dispatch = useDispatchArticleForm();
  const actions = useActionsArticle();
  const {
    user: { warehouses },
  } = useAuth();
  const state = useArticle();
  const dispacth = useDispatchArticleForm();
  const {
    article: {
      measures: { elements: measures_list },
      itemsCheckMeasure: { elements: items_id_check },
      has_lote,
      inventory: {
        detail_item: {
          items: items_detal,
          selected: {
            item_id: item_id_selected,
            warehouse_id: warehouse_id_selected,
            measure_name: measure_name_selected,
          },
        },
        filter: { warehouses_id, measures_id },
        items: warehouses_keys,
      },
    },
  } = state;

  const [showDetail, setshowDetail] = useState(true);
  const setFilter = (field, value) => {
    dispacth({
      type: types.SET_INVENTORY_ITEMS,
      payload: {
        ...state.article.inventory,
        filter: {
          ...state.article.inventory.filter,
          [field]: pluckArrayObject(value, "id"),
        },
      },
    });
  };
  const getTotalDetail = (details) => {
    return details.reduce(function (acc, obj) {
      return parseFloat(acc) + parseFloat(obj.stock);
    }, 0);
  };
  const getTotal = () => {
    let total = 0;
    Object.keys(warehouses_keys).map((code) => {
      total =
        total +
        warehouses_keys[code].items.reduce((bef, prev) => {
          return (
            bef +
            (prev.equivalent_value
              ? parseFloat(prev.stock_in_equivalent_measure_main)
              : 0)
          );
        }, 0);
    });
    return total;
  };
  const loadEntriesCheck = (inventory_warehouse) => {
    if (has_lote) {
      actions.getInventoryItemByLotesUpdated({
        item_id: inventory_warehouse.item_id,
        warehouse_id: inventory_warehouse.warehouse_id,
        measure_name: inventory_warehouse.measure_name,
      });
    } else {
      dispacth({type: types.SET_INVENTORY_ITEMS_INITIAL});
      alertWarning("Este artículo no maneja lotes");
    }
  };
  return (
    <div>
      <section className="row">
        <div className="form-group col-md-2 col-lg-2">
          <label>Almacén</label>
          <Select
            placeholder="Almacén"
            value={warehouses.filter((w) => warehouses_id.includes(w.id))}
            getOptionLabel={(option) => `${option.code} - ${option.name}`}
            getOptionValue={(option) => option.id}
            options={warehouses}
            isMulti
            onChange={(e) => setFilter("warehouses_id", e)}
            styles={customStyles}
          />
        </div>
        <div className="form-group col-md-2 col-lg-2">
          <label>Unidad de medida</label>
          <Select
            placeholder="Unidad de medida"
            value={measures_list.filter((m) => measures_id.includes(m.id))}
            getOptionLabel={(option) => `${option.name}`}
            getOptionValue={(option) => option.id}
            options={measures_list.filter((m) => items_id_check.includes(m.id))}
            onChange={(e) => setFilter("measures_id", e)}
            isMulti
            styles={customStyles}
          />
        </div>
        <div className="form-group col-md-2 col-lg-2">
          <label>&nbsp;</label>
          <div
            onClick={() => setshowDetail(!showDetail)}
            className="btn-default"
          >
            <FontAwesomeIcon icon={faEye} /> Vista{" "}
            {!showDetail ? "detalle" : "general"}
          </div>
        </div>
      </section>
      <div style={{ marginTop: "23px" }} className="col-md-12 flex">
        <section className="col-md-6">
          {Object.keys(warehouses_keys).map((code) => {
            return (
              <div style={{ marginTop: "23px" }} key={code}>
                <table className="table table-default-app">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">Almacén</th>
                      <th scope="col">Und. medida</th>
                      <th scope="col">Cant</th>
                    </tr>
                  </thead>
                  <tbody>
                    {showDetail &&
                      warehouses_keys[code].items.map((w, index) => {
                        return (
                          <tr
                            style={{
                              backgroundColor:
                                item_id_selected === w.item_id &&
                                warehouse_id_selected === w.warehouse_id &&
                                "var(--line-selected)",
                            }}
                            className="cursor-pointer"
                            onClick={() =>
                              loadEntriesCheck(w)
                            }
                            key={index}
                          >
                            <td>
                              {w.warehouse_code} - {w.warehouse_name}
                            </td>
                            <td>
                              {w.measure_name} - {w.abreviature}{" "}
                            </td>
                            <td className="txt-right">
                              {formatNumberCOP(w.stock)}
                            </td>
                          </tr>
                        );
                      })}
                    <tr
                      style={{
                        backgroundColor: "#bbbbbb",
                        borderBottomRightRadius: "12px",
                      }}
                    >
                      <td>
                        Total{" "}
                        <span>
                          {" "}
                          {code} - {warehouses_keys[code].warehouse_name}
                        </span>
                      </td>
                      <td>
                        {
                          warehouses_keys[code].equivalent_name
                        }
                      </td>
                      <td className="  font1 txt-right">
                        {formatNumberCOP(
                          warehouses_keys[code].items.reduce((bef, prev) => {
                            return (
                              bef +
                              (prev.equivalent_value
                                //? parseFloat(prev.stock) *
                                //  parseFloat(prev.equivalent_value)
                                ? parseFloat(prev.stock_in_equivalent_measure_main)
                                : 0)
                            );
                          }, 0)
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            );
          })}
          <div
            className="flex"
            style={{ marginTop: "12px", fontSize: "0.8rem" }}
          >
            <div className="flex0 font1">Total</div>
            <div
              className="flex1 flex"
              style={{
                padding: "3px",
                border: "var(--black) solid 1px",
                marginLeft: "12px",
                borderRadius: "12px",
                backgroundColor: "var(--green)",
              }}
            >
              <span className="txt-left font1 flex1 total-inventory">
                Und. medida: {state.article.measure_name_main}
              </span>
              <span className="txt-right font1 flex1 total-inventory">
                {formatNumberCOP(getTotal())}
              </span>
            </div>
          </div>
        </section>
        

        {items_detal.length>0 &&(
          <section style={{ margin: "23px" }}>
          <table className="table table-default-app">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Lote</th>
                <th scope="col">Cant.</th>
                <th scope="col">Fecha vencimiento</th>
              </tr>
            </thead>
            <tbody>
              {items_detal.map((w, index) => {
                if (w.date_expired==null) {
                  w.date_expired = "N.A";
                }
                return (
                  <tr className="cursor-pointer" key={index}>
                    <td>{w.lote}</td>
                    <td className="txt-right">{formatNumberCOP(w.stock)}</td>
                    <td className="txt-right">{w.date_expired}</td>
                  </tr>
                );
              })}
              <tr
                style={{
                  backgroundColor: "#bbbbbb",
                  borderBottomRightRadius: "12px",
                }}
              >
                <td className="font1" colSpan={2}>
                  <div
                    style={{ width: "100%", justifyContent: "space-between" }}
                    className="flex"
                  >
                    Total
                    <span className="txt-right">
                      {formatNumberCOP(getTotalDetail(items_detal))}
                    </span>
                  </div>
                </td>
                <td>
                  <span>{measure_name_selected}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        )}


      </div>
    </div>
  );
};

export default Inventory;
